export interface IAccountSummaryState {
    isLoading: boolean;
    accountSummaryData: IAccountSummaryResponse;
}

export interface IRecentTransactionState {
    isLoading: boolean;
    recentTransactionData: IRecentTransactionResponse;
}
export interface ITransactionChartState {
    isLoading: boolean;
    transactionChartData: ITransactionChartResponse;
}

export const RECEIVE_ACCOUNTSUMMARY = "RECEIVE_ACCOUNTSUMMARY";
export const REQUEST_ACCOUNTSUMMARY = "REQUEST_ACCOUNTSUMMARY";

export const RECEIVE_RECENTTRANSACTION = "RECEIVE_RECENTTRANSACTION";
export const REQUEST_RECENTTRANSACTION = "REQUEST_RECENTTRANSACTION";

export const RECEIVE_CHARTDATA = "RECEIVE_CHARTDATA";
export const REQUEST_CHARTDATA = "REQUEST_CHARTDATA";

export interface IRequestAccountSummaryAction {
    type: typeof REQUEST_ACCOUNTSUMMARY;
}

export interface IReceiveAccountSummarysAction {
    type: typeof RECEIVE_ACCOUNTSUMMARY;
    accountSummaryData: IAccountSummaryResponse;
}

export interface IRequestRecentTransactionAction {
    type: typeof REQUEST_RECENTTRANSACTION;
}

export interface IReceiveRecentTransactionAction {
    type: typeof RECEIVE_RECENTTRANSACTION;
    recentTransactionData: IRecentTransactionResponse;
}

export interface IRequestTransactionChartAction {
    type: typeof REQUEST_CHARTDATA;
}

export interface IReceiveTransactionChartAction {
    type: typeof RECEIVE_CHARTDATA;
    transactionChartData: ITransactionChartResponse;
}

export type AccountSummaryType = IRequestAccountSummaryAction | IReceiveAccountSummarysAction;

export type RecentTransactionType = IRequestRecentTransactionAction | IReceiveRecentTransactionAction;

export type TransactionChartType = IRequestTransactionChartAction | IReceiveTransactionChartAction;

export type TransactionType = AccountSummaryType | RecentTransactionType | TransactionChartType;

export interface ITransactionChartResponse {
    data: IChartData[];
    "transaction-month-dollar-value": number;
    "transaction-scanned-month": number;
    "transaction-scanned-week": number;
    "transaction-week-dollar-value": number;
    "transactions-alerted-month": number;
    "transactions-alerted-week": number;
}
export interface IChartData {
    month: string;
    year: string;
    "regular-transactions": string;
    "alerted-transactions": string;
    "flagged-transactions": string;
}
export interface IRecentTransactionResponse {
    data: ItransactionData[];
    metadata: ItransactionTotalNumber;
}
export interface ItransactionTotalNumber {
    "num-total": string;
}
export interface ItransactionData {
    id: number;
    "transaction-id": string;
    "transaction-date": string;
    merchant: string;
    "account-name": string;
    "account-nickname": string;
    "account-number": string;
    "account-id": string;
    "category-name": string;
    description: string;
    amount: number;
    "is-fraudulent-transaction": string;
    "is-triggered-alert": string;
    "transaction-type": string;
}
export interface IAccountSummaryResponse {
    data?: IAccountSummary[];
    "total-accounts": number;
    "month-transactions": number;
    "month-alerts": number;
}
export interface IAccountSummary {
    "account-id": number;
    "account-name": string;
    "account-nickname": string;
    "account-number": number;
    "account-balance": number;
    alerts: number;
    transactions: any;
    "account-type": string;
    "account-type-id": number;
    "idf-monitor-id": string;
    logo?: string;
    "logo-alt"?: string;
    isDisconnected?: boolean;
}
